import React, { createContext, ReactNode, useContext, useEffect, useRef, useState } from 'react';
type Layout = {
  width: number;
  compact: boolean;
  wide: boolean;
};
type LayoutProviderProps = {
  children: ReactNode;
  className?: string;
};
const LayoutContext = createContext<Layout>({
  width: 1280,
  compact: false,
  wide: true
});

// Layout responds to the width of the experience itself (not the window),
// so the same Snak renders correctly full-screen or inside a phone frame.
export function LayoutProvider({
  children,
  className = ''
}: LayoutProviderProps) {
  const ref = useRef<HTMLDivElement>(null);
  const [width, setWidth] = useState(1280);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    setWidth(el.clientWidth);
    const ro = new ResizeObserver(([entry]) => setWidth(entry.contentRect.width));
    ro.observe(el);
    return () => ro.disconnect();
  }, []);
  return <LayoutContext.Provider value={{
    width,
    compact: width < 768,
    wide: width >= 1024
  }} data-id="element-239" data-mp="2q3uffy4d49po">
      <div ref={ref} className={className} data-id="element-240" data-mp="1aer7crhhlnd7">
        {children}
      </div>
    </LayoutContext.Provider>;
}
export function useLayout(): Layout {
  return useContext(LayoutContext);
}